import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import DownloadPic from "../../../../assets/images/child-profile-created.png";

const Download = ({ showModal, closeModal, getLangTranslation }) => {
  const modalRef = useRef();

  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">{getLangTranslation("DOWNLOAD", "Download")}</h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <img
              className="content-200 mx-auto d-block"
              src={DownloadPic}
              alt=""
            />
            <h6 className="my-6 text-blue-900 text-center">
              {getLangTranslation("DOWNLOAD_COMPLETE", "Download completed")}
            </h6>
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={closeModal}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span className="btn-upper-case">{getLangTranslation("PIN_CODE_RECOVERY_GOT_IT", "Got it")}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
